<template>
    <div>
        <ProjectServicesTop />
        <div class="mainTransportProducts">
            <div class="titleStyle">
                <div class="titleFont">建材物流服务</div>
                <div class="conentFont">
                    <div class="divide"></div>
                    <span class="enFont"
                        >Building materials logistics service</span
                    >
                    <div class="divide"></div>
                </div>
            </div>
            <div class="describeFont">
                {{ mainTransportProductsList.description }}
            </div>
            <div class="mainTransportProductsContent">
                <div class="mainTransportProductsContentImg"></div>
                <div class="mainTransportProductsContentList">
                    <div
                        class="mainTransportProductsContentItem"
                        v-for="(
                            item, idx
                        ) in mainTransportProductsList.cmsArticleList"
                        :key="idx"
                        v-show="idx < 4"
                        @mouseenter="changeImg(item, idx)"
                    >
                        <div class="itemTitle">{{ item.title }}</div>
                        <div class="itemContent">
                            {{ item.description }}
                        </div>
                        <div class="activeLine"></div>
                    </div>
                </div>
            </div>
        </div>
        <!--        <div class="transportationService">-->
        <!--            <div class="titleStyle">-->
        <!--                <div class="titleFont">运输服务</div>-->
        <!--                <div class="conentFont">-->
        <!--                    <div class="divide"></div>-->
        <!--                    <span class="enFont">TRANSPORTATION SERVICE</span>-->
        <!--                    <div class="divide"></div>-->
        <!--                </div>-->
        <!--            </div>-->
        <!--            <div class="transportationServiceList">-->
        <!--                <div-->
        <!--                    class="transportationServiceItem"-->
        <!--                    v-for="(item, idx) in transportationServiceList"-->
        <!--                    :key="idx"-->
        <!--                    v-show="idx < 5"-->
        <!--                    :style="{-->
        <!--                        backgroundImage: 'url(' + item.image + ')',-->
        <!--                    }"-->
        <!--                >-->
        <!--                    <div-->
        <!--                        :class="[-->
        <!--                            'itemFont',-->
        <!--                            idx % 2 == 0 ? 'itemTop' : 'itemBot',-->
        <!--                        ]"-->
        <!--                    >-->
        <!--                        {{ item.title }}-->
        <!--                    </div>-->
        <!--                </div>-->
        <!--            </div>-->
        <!--        </div>-->
    </div>
</template>
<script>
import $ from "jquery";
import ProjectServicesTop from "@/components/ProjectServicesTop.vue";
import { getAction } from "@/api/services";
export default {
    name: "ProjectServices",
    components: {
        ProjectServicesTop,
    },
    data() {
        return {
            url: "/jhwlweb/gwweb/cmsArticleCategory/queryServiceList",
            mainTransportProductsList: [],
            transportationServiceList: [],
        };
    },
    created() {
        this.getInfo();
    },
    methods: {
        changeImg(item, idx) {
            $(".mainTransportProductsContentImg").css(
                "background-image",
                "url(" + item.image + ")"
            );
            $(".mainTransportProductsContentItem").removeClass(
                "mainTransportProductsContentItemAction"
            );
            $(".mainTransportProductsContentItem")
                .eq(idx)
                .addClass("mainTransportProductsContentItemAction");
        },
        getInfo() {
            let that = this;
            let parmas = {
                menuCategory: 20,
            };
            getAction(that.url, parmas).then((res) => {
                if (res.code == 200 && res.success) {
                    let arr = res.result.records;
                    arr.forEach((item, idx) => {
                        if (idx == 0) {
                            that.mainTransportProductsList = item;
                            $(".mainTransportProductsContentImg").css(
                                "background-image",
                                "url(" + item.cmsArticleList[0].image + ")"
                            );
                            setTimeout(() => {
                                $(".mainTransportProductsContentItem")
                                    .eq(0)
                                    .addClass(
                                        "mainTransportProductsContentItemAction"
                                    );
                            }, 10);
                        } else {
                            that.transportationServiceList =
                                item.cmsArticleList;
                        }
                    });
                }
            });
        },
    },
};
</script>
<style lang="less" scoped>
.bgSet {
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;
}
.typeArea {
    max-width: 1100px;
    margin: 0 auto;
}
.titleStyle {
    .typeArea();
    width: 100%;
    padding-bottom: 80px;
    padding-top: 90px;
    text-align: center;
    .titleFont {
        font-family: "阿里巴巴普惠体";
        font-size: 32px;
        line-height: 28px;
        letter-spacing: 2px;
        color: #333333;
    }
    .conentFont {
        margin-top: 8px;
        .divide {
            display: inline-block;
            vertical-align: super;
            width: 20px;
            height: 2px;
            background-color: #0052d9;
        }
        .enFont {
            margin: 0 10px;
            font-family: "微软雅黑";
            font-size: 16px;
            letter-spacing: 0px;
            color: #333333;
            opacity: 0.5;
        }
    }
}
.mainTransportProducts {
    .typeArea();
    .describeFont {
        padding: 0 50px;
        font-size: 18px;
        letter-spacing: 1.1px;
        line-height: 1.6em;
        color: #333333;
        margin-bottom: 100px;
    }
    .mainTransportProductsContent {
        margin-bottom: 20px;
        .mainTransportProductsContentImg {
            width: 100%;
            height: 380px;
            .bgSet();
        }
        .mainTransportProductsContentList {
            display: flex;
            .mainTransportProductsContentItem {
                width: 100%;
                position: relative;
                padding: 40px 20px 60px;
                background-color: #f2f3f5;
                .itemTitle {
                    font-family: "优设标题黑";
                    font-size: 32px;
                    color: #333333;
                }
                .itemContent {
                    margin-top: 30px;
                    font-size: 14px;
                    color: #666666;
                }
                .activeLine {
                    display: none;
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    width: 100%;
                    height: 4px;
                    background-color: #0052d9;
                }
            }
            .mainTransportProductsContentItemAction {
                background-color: #fbfbfb;
                .activeLine {
                    display: block;
                }
            }
        }
    }
}
.transportationService {
    background: #fbfbfb;
    padding-bottom: 70px;
    .transportationServiceList {
        .typeArea();
        display: flex;
        .transportationServiceItem {
            .bgSet();
            width: 220px;
            height: 400px;
            position: relative;
            .itemFont {
                position: absolute;
                left: 0;
                width: 100%;
                background-image: linear-gradient(
                    90deg,
                    #0052d9 0%,
                    transparent 100%
                );
                font-family: "优设标题黑";
                font-size: 32px;
                letter-spacing: 2px;
                color: #ffffff;
            }
            .itemTop {
                top: 70px;
            }
            .itemBot {
                bottom: 70px;
            }
        }
        .transportationServiceItem:hover {
            transition: all 0.3s;
            transform: scale(1.1);
            z-index: 3;
        }
    }
}
</style>
